const state = {
  records: [],
};

export const getters = {
  getStages(_state) {
    return _state.records;
  },
};

export const actions = {
  addStage({ commit, dispatch }, stage) {
    commit('ADD_STAGE', stage);
    dispatch('pipelines/upsertRealtimeStage', stage, { root: true });
  },

  updateStage({ commit, dispatch }, stage) {
    commit('UPDATE_STAGE', stage);
    dispatch('pipelines/upsertRealtimeStage', stage, { root: true });
  },

  deleteStage({ commit, dispatch }, stagePayload) {
    const stage = stagePayload.data || stagePayload;
    const stageId = stage.id || stage;

    commit('DELETE_STAGE', stageId);
    dispatch('pipelines/deleteRealtimeStage', stage, { root: true });
  },

  reorderStages({ dispatch }, payload) {
    dispatch('pipelines/reorderRealtimeStages', payload, { root: true });
  },
};

export const mutations = {
  ADD_STAGE(_state, stage) {
    _state.records.push(stage);
  },

  UPDATE_STAGE(_state, stage) {
    const index = _state.records.findIndex(s => s.id === stage.id);
    if (index !== -1) {
      _state.records[index] = { ..._state.records[index], ...stage };
    }
  },

  DELETE_STAGE(_state, stageId) {
    _state.records = _state.records.filter(s => s.id !== stageId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
